export enum EnvironmentEnum {
  PROD = 'production',
  STAGING = 'staging',
  LOCAL = 'local',
}

export type Environment = {
  isProduction: boolean;
  mtbeEndpoint: string;
  complianceEndpoint: string;
  name: string;
  loginUrl: string;
  authSuccessRefreshIntervalMillis: number;
  mtfeEndpoint: string;
  ldClientSideId: string;
  devPortal: string;
};
